import type { ReactElement } from 'react';
import { useState } from 'react';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import { ThemedProgressDialogButton } from '../ThemedComponents';

import {
    CANCEL_REASON_MAX_LENGTH,
    generateCancelReasonHelperText,
} from './utils';

interface GiveCancelReasonProps {
    onCancel: () => void;
    onConfirm: (reason: string) => void;
}

const GiveCancelReason = ({
    onCancel,
    onConfirm,
}: GiveCancelReasonProps): ReactElement => {
    const [cancelReason, setCancelReason] = useState('');

    const isOverLimit = cancelReason.length > CANCEL_REASON_MAX_LENGTH;
    const isConfirmDisabled = cancelReason.trim().length < 3 || isOverLimit;

    return (
        <Stack
            spacing={5}
            sx={{
                marginTop: '20px !important',
            }}
            useFlexGap
        >
            <TextField
                value={cancelReason}
                label="Reason for cancellation"
                sx={{ marginTop: 0 }}
                placeholder="Type here..."
                helperText={generateCancelReasonHelperText(cancelReason)}
                error={isOverLimit}
                variant="outlined"
                multiline
                fullWidth
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                onChange={(e) => {
                    setCancelReason(e.target.value);
                }}
            />

            <Stack
                direction="row"
                spacing={4}
                useFlexGap
            >
                <ThemedProgressDialogButton
                    variant="outlined"
                    onClick={() => {
                        onCancel();
                    }}
                >
                    Don&apos;t cancel
                </ThemedProgressDialogButton>

                <ThemedProgressDialogButton
                    disabled={isConfirmDisabled}
                    onClick={() => {
                        onConfirm(cancelReason);
                    }}
                >
                    Confirm
                </ThemedProgressDialogButton>
            </Stack>
        </Stack>
    );
};

export { GiveCancelReason };
export type { GiveCancelReasonProps };
